<style lang="scss" scoped>
.topbox {
    width: 100%;
    max-width: 580px;

    #topUp {
        position: fixed;
        right: 25px;
        bottom: 75px;
        width: 30px;
        height: 30px;
        z-index: 1000;
        box-shadow: 0px 0px 4px 4px #ecefef;
        border-radius: 600px;
    }

    .topUp-hide {
        display: none !important;
    }
}
</style>
<template>
    <!-- 回到顶部 -->
    <div class="topbox">
        <a id="topUp" :style="{ bottom: ('number' == typeof bottom ? bottom + 'px' : bottom) }" v-show="topShow"
           @click="onClick">
            <img style="width: 100%;height: 100%;" src="~@/assets/img/top2.png" alt="">
        </a>
        <a class="topUp-hide" v-show="topShow" :href="elname">

        </a>
    </div>
</template>

<script>
export default {
    name: 'cm-top-up',
    data() {
        return {
            topShow: false,
        };
    },
    props: {
        elname: {
            type: String,
            required: false,
            default: '#topAnchor'
        },
        bottom: {
            type: [String, Number],
            default: 65
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener("scroll", this.init); //监听页面滚动
        });
    },
    methods: {
        init() {
            this.topShow = this.getScrollTop() >= 400
        },
        onClick() {
            this.toTop()
        },
        getScrollTop() {
            return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        },
        toTop() {
            // 距离顶部距离
            var scrollTop = this.getScrollTop()
            // 最多花费时间
            var max_time = 80;
            // 循环定时器指针
            var Interval = null;
            // 执行周期时间
            var interval_time = 1;
            // 已花时间 
            var time = 0;
            // 平均速度
            var speed = (scrollTop / max_time * interval_time).toFixed(4);
            console.log('speed', speed, 'scrollTop', scrollTop);
            Interval = setInterval(() => {
                time += interval_time
                let end;
                if (time >= max_time) {
                    end = 0;
                } else {
                    scrollTop = end = scrollTop - speed;
                }
                end = end < 5 ? 0 : end;
                if (end >= 0) {
                    try {
                        window.scrollTo(0, end)
                    } catch (error) {
                        console.log('移动到顶部出错，' + error);
                        clearInterval(Interval)
                    }
                }
                if (end <= 0) {
                    clearInterval(Interval)
                }
            }, interval_time);
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/CmTopUp/index.vue